import { useState } from "react";
import { BadgeCheck, FileUp, Sparkles, Briefcase } from "lucide-react";
import MomoDialog from "./MomoDialog";
import { cedi } from "../lib/api";

export const MEMBERSHIP = { title: "Dexterity Consult membership & resume review", price: 100, note: "one-time" };

export const MembershipCard = ({ onPaid, compact = false }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative overflow-hidden rounded-lg bg-[#1A0B24] text-white p-6 sm:p-8 border-l-4 border-[#D4AF37]" data-testid="membership-card">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div>
          <div className="dx-eyebrow">Step 1 · Join the platform</div>
          <h3 className="font-display text-2xl font-bold mt-2">Activate your membership for {cedi(100)}</h3>
          {!compact && (
            <ul className="mt-4 grid sm:grid-cols-3 gap-3 text-sm text-white/80">
              <li className="flex gap-2"><FileUp className="w-4 h-4 text-[#D4AF37] shrink-0" />Upload your resume</li>
              <li className="flex gap-2"><Sparkles className="w-4 h-4 text-[#D4AF37] shrink-0" />We tidy it up professionally</li>
              <li className="flex gap-2"><Briefcase className="w-4 h-4 text-[#D4AF37] shrink-0" />Get automatched to employers</li>
            </ul>
          )}
        </div>
        <button className="dx-btn-gold px-7 py-3 shrink-0" onClick={() => setOpen(true)} data-testid="membership-pay-btn">Join for {cedi(100)}</button>
      </div>
      <MomoDialog item={MEMBERSHIP} endpoint="/payments/membership" open={open} onOpenChange={setOpen} onPaid={() => { setOpen(false); onPaid(); }} />
    </div>
  );
};

export const MemberBadge = () => (
  <span className="inline-flex items-center gap-1.5 rounded-md bg-[#FFF4D4] text-[#8a6a00] px-2.5 py-1 text-xs font-bold" data-testid="member-badge">
    <BadgeCheck className="w-3.5 h-3.5" />Active member
  </span>
);
